module.exports = __webpack_public_path__ + "304ea70a7cc448b33e1d9fdfcac1002c.png";